/* Native disclosures remain usable without JavaScript. Enhance only product details. */
(() => {
  function enhanceSizeSummary(root) {
    root.querySelectorAll('.tanoti-size-options').forEach(fieldset => {
      if (fieldset.nextElementSibling?.classList.contains('tanoti-size-summary')) return;
      const summary = document.createElement('div');
      summary.className = 'tanoti-size-summary';
      summary.setAttribute('role', 'status');
      summary.setAttribute('aria-live', 'polite');
      fieldset.after(summary);
      const modalId = fieldset.querySelector('modal-opener[data-modal]')?.dataset.modal?.slice(1);
      const chart = modalId ? document.getElementById(modalId) : fieldset.querySelector('.product-popup-modal');
      const normalize = value => value.trim().toUpperCase().replace(/^XXL$/, '2XL').replace(/^XXXL$/, '3XL');
      const update = () => {
        const size = fieldset.querySelector('input:checked')?.value;
        const tables = [...(chart?.querySelectorAll('table') || [])];
        const matches = [];
        tables.forEach(table => {
          const rows = [...table.rows];
          const header = rows.find(row => /\bsize\b/i.test(row.textContent) && /chest|bust|waist|hip|length|shoulder|sleeve/i.test(row.textContent));
          if (!header) return;
          const headers = [...header.cells].map(cell => cell.textContent.trim());
          const sizeIndex = headers.findIndex(label => /\bsize\b/i.test(label));
          const row = rows.slice(rows.indexOf(header) + 1).find(row => normalize(row.cells[sizeIndex]?.textContent || '') === normalize(size || ''));
          if (!row) return;
          const measurements = headers.flatMap((label, i) => /chest|bust|waist|hip|length|shoulder|sleeve/i.test(label) && row.cells[i]?.textContent.trim() ? [{label, value: row.cells[i].textContent.trim()}] : []);
          if (measurements.length) matches.push({header, measurements, table});
        });
        summary.replaceChildren();
        if (matches.length !== 1) {
          summary.textContent = 'Compare with a garment that fits you. See Size Chart for measurements.';
          return;
        }
        const {header, measurements, table} = matches[0];
        const guide = table.closest('tanoti-size-guide');
        const unit = guide?.querySelector('[data-unit][aria-pressed="true"]')?.dataset.unit || guide?.dataset.sourceUnit;
        const unitText = unit === 'cm' || /centimetres|\bcm\b/i.test(header.textContent) ? 'cm' : unit === 'in' || /inches|inch/i.test(header.textContent) ? 'inches' : '';
        const title = document.createElement('p');
        title.className = 'tanoti-size-summary__title';
        title.textContent = `${size} measurements${unitText ? ` · ${unitText}` : ''}`;
        const values = document.createElement('dl');
        measurements.forEach(({label, value}) => {
          const item = document.createElement('div');
          const term = document.createElement('dt');
          const measurement = document.createElement('dd');
          term.textContent = label;
          measurement.textContent = value;
          item.append(term, measurement);
          values.append(item);
        });
        summary.append(title, values);
      };
      fieldset.addEventListener('change', update);
      chart?.addEventListener('click', event => { if (event.target.closest('[data-unit]')) setTimeout(update, 0); });
      update();
    });
  }
  function enhanceProductDetails(root = document) {
    root.querySelectorAll('product-info').forEach(info => {
      const panels = [...info.querySelectorAll(':scope > .product__accordion.quick-add-hidden')];
      if (!panels.length || info.querySelector('.tanoti-details-tabs')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'tanoti-details-tabs';
      const list = document.createElement('div');
      list.className = 'tanoti-details-tabs__list';
      list.setAttribute('role', 'tablist');
      list.setAttribute('aria-label', 'Product information');
      panels[0].before(wrapper);
      wrapper.append(list);
      const buttons = panels.map((panel, index) => {
        const details = panel.querySelector('details');
        const summary = details.querySelector('summary');
        const button = document.createElement('button');
        button.type = 'button';
        button.id = `${details.id}-tab`;
        panel.id = `${details.id}-panel`;
        const label = document.createElement('span');
        label.textContent = summary.textContent.trim();
        button.append(label);
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', panel.id);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', button.id);
        panel.tabIndex = 0;
        details.removeAttribute('name');
        details.open = true;
        summary.hidden = true;
        list.append(button);
        wrapper.append(panel);
        button.addEventListener('click', () => select(index));
        button.addEventListener('keydown', event => {
          const rtl = getComputedStyle(list).direction === 'rtl';
          let next;
          if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          next = (next + buttons.length) % buttons.length;
          select(next);
          buttons[next].focus({preventScroll: true});
        });
        return button;
      });
      const indicator = document.createElement('span');
      indicator.className = 'tanoti-details-tabs__indicator';
      indicator.setAttribute('aria-hidden', 'true');
      list.prepend(indicator);
      let selected = 0;
      let panelAnimation;
      const positionIndicator = () => {
        indicator.style.width = `${buttons[selected].offsetWidth}px`;
        indicator.style.transform = `translateX(${buttons[selected].offsetLeft}px)`;
      };
      new ResizeObserver(positionIndicator).observe(list);
      function select(index) {
        const previous = selected;
        selected = index;
        panelAnimation?.cancel();
        buttons.forEach((button, i) => {
          button.setAttribute('aria-selected', String(i === index));
          button.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        positionIndicator();
        if (previous !== index && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          panelAnimation = panels[index].animate([
            { opacity: 0, transform: `translateX(${index > previous ? 28 : -28}px)` },
            { opacity: 1, transform: 'translateX(0)' }
          ], { duration: 520, easing: 'cubic-bezier(.4, 0, .2, 1)' });
        }
      }
      select(0);
    });
  }
  let zoomDialog;
  function enhanceZoom(root) {
    root.querySelectorAll('media-gallery .media-type-image').forEach(container => {
      if (container.querySelector('.tanoti-photo-zoom')) return;
      const source = container.querySelector('.product__media img');
      if (!source) return;
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'tanoti-photo-zoom';
      trigger.setAttribute('aria-label', 'Zoom product photo');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="10" cy="10" r="6.5"/><path d="m15 15 6 6M7 10h6M10 7v6"/></svg>';
      container.append(trigger);
      trigger.addEventListener('click', () => {
        if (!zoomDialog) {
          zoomDialog = document.createElement('dialog');
          zoomDialog.className = 'tanoti-zoom';
          zoomDialog.setAttribute('aria-label', 'Product photo zoom');
          zoomDialog.innerHTML = '<div class="tanoti-zoom__toolbar"><button type="button" data-magnify aria-pressed="false">Zoom in</button><button type="button" data-close aria-label="Close photo zoom">Close ×</button></div><div class="tanoti-zoom__canvas" tabindex="0" aria-label="Photo. Scroll to explore when zoomed"><p data-zoom-status role="status"></p><img alt=""></div>';
          document.body.append(zoomDialog);
          zoomDialog.querySelector('[data-close]').addEventListener('click', () => zoomDialog.close());
          const toggle = () => {
            const image = zoomDialog.querySelector('img');
            if (!image.complete || !image.naturalWidth) return;
            const fittedWidth = image.getBoundingClientRect().width;
            const enlarged = zoomDialog.classList.toggle('is-zoomed');
            image.style.width = enlarged ? `${fittedWidth * 2}px` : '';
            zoomDialog.querySelector('[data-magnify]').textContent = enlarged ? 'Fit photo' : 'Zoom in';
            zoomDialog.querySelector('[data-magnify]').setAttribute('aria-pressed', String(enlarged));
          };
          zoomDialog.querySelector('[data-magnify]').addEventListener('click', toggle);
          zoomDialog.querySelector('img').addEventListener('click', toggle);
          zoomDialog.addEventListener('click', event => { if (event.target === zoomDialog) zoomDialog.close(); });
          zoomDialog.addEventListener('close', () => {
            document.body.classList.remove('tanoti-zoom-open');
            zoomDialog.opener?.focus({preventScroll: true});
          });
        }
        zoomDialog.opener = trigger;
        zoomDialog.classList.remove('is-zoomed');
        const image = zoomDialog.querySelector('img');
        const status = zoomDialog.querySelector('[data-zoom-status]');
        const magnify = zoomDialog.querySelector('[data-magnify]');
        magnify.disabled = true;
        status.hidden = false;
        status.textContent = 'Loading photo…';
        image.onload = () => { magnify.disabled = false; status.hidden = true; };
        image.onerror = () => { status.textContent = 'Photo could not load. Please close and try again.'; };
        image.style.width = '';
        image.src = container.dataset.zoomSrc || source.currentSrc || source.src;
        image.alt = source.alt || 'Product photo';
        zoomDialog.querySelector('[data-magnify]').textContent = 'Zoom in';
        zoomDialog.querySelector('[data-magnify]').setAttribute('aria-pressed', 'false');
        zoomDialog.showModal();
        document.body.classList.add('tanoti-zoom-open');
        zoomDialog.querySelector('.tanoti-zoom__canvas').scrollTo(0, 0);
      });
    });
  }
  function enhanceOffers(root) {
    root.querySelectorAll('.tanoti-offers').forEach(slider => {
      if (slider.querySelector('.tanoti-offers__controls')) return;
      const items = [...slider.querySelectorAll('.offer__item')];
      if (items.length < 2) return;
      const controls = document.createElement('div');
      controls.className = 'tanoti-offers__controls';
      let current = 0;
      let paused = false;
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const show = index => {
        current = index;
        items.forEach((item, i) => { item.hidden = i !== index; item.classList.toggle('active', i === index); });
      };
      const next = document.createElement('button');
      next.type = 'button';
      next.setAttribute('aria-label', 'Next offer');
      next.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.4"><path d="m7 5 5 5-5 5"/></svg>';
      next.addEventListener('click', () => show((current + 1) % items.length));
      controls.append(next);
      const pause = document.createElement('button');
      pause.type = 'button';
      pause.className = 'tanoti-offers__pause';
      pause.textContent = 'Ⅱ';
      pause.setAttribute('aria-label', 'Pause automatic offers');
      pause.addEventListener('click', () => {
        paused = !paused;
        pause.textContent = paused ? '▷' : 'Ⅱ';
        pause.setAttribute('aria-label', `${paused ? 'Play' : 'Pause'} automatic offers`);
      });
      controls.append(pause);
      slider.append(controls);
      show(0);
      const timer = setInterval(() => {
        if (!slider.isConnected) { clearInterval(timer); return; }
        if (paused || reducedMotion.matches || document.hidden || slider.matches(':hover, :focus-within')) return;
        show((current + 1) % items.length);
      }, 5000);
    });
  }
  function enhance(root = document) { enhanceProductDetails(root); enhanceZoom(root); enhanceOffers(root); enhanceSizeSummary(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();

